import React from 'react';
import { RecordedItem } from './CompliancePlayer.types';

interface RecordedListProps {
  items: RecordedItem[];
  selectedId?: string;
  onSelect: (id: string) => void;
}

const RecordedList: React.FC<RecordedListProps> = ({ items, selectedId, onSelect }) => {
  if (items.length === 0) {
    return (
      <div className="compliance-player__recorded">
        <div className="compliance-player__recorded-list is-empty">No recordings for the selected filters.</div>
      </div>
    );
  }

  return (
    <div className="compliance-player__recorded">
      <div className="compliance-player__recorded-list">
        {items.map((item) => {
          const isSelected = item.id === selectedId;
          return (
            <button
              key={item.id}
              className={`compliance-player__recorded-item${isSelected ? ' is-selected' : ''}`}
              onClick={() => onSelect(item.id)}
            >
              <div className="compliance-player__recorded-content">
                <div className="compliance-player__recorded-title">{item.title}</div>
                <div className="compliance-player__recorded-meta">
                  {item.channel} · {item.date}
                </div>
              </div>
              <span className="compliance-player__recorded-size">{item.size}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default RecordedList;
